/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spreadsheet from "react-spreadsheet";
import * as ReactDOM from "react-dom";
import { AlertModal } from "../../../common";
import {
  DEFAULT_SHEET_ROWS,
  defaultCellFieldData,
} from "../../../utils/configs";
import { useTranslation } from "react-i18next";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegCheckSquare } from "react-icons/fa";
import { BiSolidSelectMultiple } from "react-icons/bi";
import { FaArrowUp } from "react-icons/fa";

const iIndexes = {
  RATE_NAME: 0,
  RATE_From: 1,
  RATE_To: 2,
  RATE_Value: 3,
};
const sheetLabels = ["Name", "From", "To", "Value"];

const createEmptySheetRows = (noOfRows = DEFAULT_SHEET_ROWS) => {
  const rows = [];
  for (var i = 0; i < noOfRows; i++) {
    rows.push([
      {
        ...defaultCellFieldData,
        id: "Name",
        className: "cellClass cellClass_" + i + "_" + iIndexes.RATE_NAME,
        required: true,
      },
      {
        ...defaultCellFieldData,
        id: "from",
        className: "cellClass cellClass_" + i + "_" + iIndexes.RATE_From,
        required: true,
        type: "number",
      },
      {
        ...defaultCellFieldData,
        id: "To",
        className: "cellClass cellClass_" + i + "_" + iIndexes.RATE_To,
        required: true,
        type: "number",
      },
      {
        ...defaultCellFieldData,
        id: "Value",
        className: "cellClass cellClass_" + i + "_" + iIndexes.RATE_Value,
        required: true,
        type: "number",
      },
    ]);
  }
  return rows;
};

const initialData = createEmptySheetRows(DEFAULT_SHEET_ROWS);

export const CrewCommisionCreate = ({ onRowSelect, slabs }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const state = {
    isInvalidAccess: false,
    message: "",
    isEditForm: false,
  };
  const [count, setCount] = useState(1);

  const [sheetData, setSheetData] = useState(initialData);
  const [hoveredCell, setHoveredCell] = useState(null);
  const [spreadsheetErrors, setSpreadsheetErrors] = useState([]);
  const modelStyle = { maxWidth: "50%", margin: "auto 10% 100% 10%" };
  const [activeCell, setActiveCell] = useState({});
  const [errorDetails, setErrorDetails] = useState([]);

  
  useEffect(() => {
    const updatedSheetData = sheetData.map((row, rowIndex) => {
      return row.map((cell, colIndex) => {
        let hasError = false;
        let errorMessage = '';
  
        if (errorDetails.length > 0) {
          const error = errorDetails.find(
            (err) => Number(err.row) === rowIndex && Number(err.col) === colIndex
          );
  
          hasError = !!error;
          errorMessage = hasError ? error.message : '';
        }
  
        return {
          ...cell,
          className: `cellClass cellClass_${rowIndex}_${colIndex}${hasError ? ' errorCellData' : ''}`,
          errorMessage
        };
      });
    });
  
    setSheetData(updatedSheetData);
  }, [errorDetails]); 
  
  
  

  useEffect(() => {
    if (slabs && slabs.length > 0) {
      setEditTransferItemsToSheet({ items: slabs });
    }
  }, [slabs]);

  const handleRowClick = () => {
    if (onRowSelect) {
      onRowSelect(sheetData);
    } else {
      console.error("onRowSelect function is not provided!");
    }
  };

  const setEditTransferItemsToSheet = (transferDetails) => {
    const items = transferDetails.items;
    const updatedSpreadsheetData = createEmptySheetRows(items.length);

    items.forEach((item, i) => {
      updatedSpreadsheetData[i][iIndexes.RATE_NAME].value = item.name;
      updatedSpreadsheetData[i][iIndexes.RATE_From].value = item.from;
      updatedSpreadsheetData[i][iIndexes.RATE_To].value = item.to;
      updatedSpreadsheetData[i][iIndexes.RATE_Value].value = item.value;
    });

    ReactDOM.flushSync(() => {
      setSheetData([...updatedSpreadsheetData]);
    });
  };

  const addRowsToSheet = (rowsToAdd = 10) => {
    const newRows = createEmptySheetRows(rowsToAdd);
    setSheetData([...sheetData, ...newRows]);
  };

  const validateSheetData = (data) => {
    
    const errors = [];
  
    data.forEach((row, index) => {
      
      const fromVal = parseFloat(row[iIndexes.RATE_From]?.value);
      const toVal = parseFloat(row[iIndexes.RATE_To]?.value);
  
      if (!isNaN(fromVal)) {
        if (index === 0 && fromVal !== 0) {
          errors.push({ row: index, col: iIndexes.RATE_From, message: 'Value must be equal to 0' });
        }
  
        if (index > 0) {
          const prevToVal = parseFloat(data[index - 1][iIndexes.RATE_To]?.value);
          if (!isNaN(prevToVal) && fromVal !== prevToVal) {
            errors.push({ row: index, col: iIndexes.RATE_From, message:` Value must be equal to ${prevToVal} `});
          }
        }
      }
  
      if (!isNaN(fromVal) && !isNaN(toVal)) {
        if (toVal <= fromVal) {
          errors.push({ row: index, col: iIndexes.RATE_To, message: `Must be greater than  ${fromVal} `});
        }
      }
    });
  
    setErrorDetails(errors);
  }
  function insertRowAbove(e){
    const index=activeCell.row;
    let updatedDataSheet = JSON.parse(JSON.stringify( sheetData ));
    const updatedRow = sheetLabels.map(cell => {
        const updatedClass = cell.className?.replace(/cellClass_\d+_(\d+)/g, `cellClass_${index}_$1`);
        return {
          ...cell,
          className: updatedClass ?? cell.className
        };
      });
      updatedDataSheet.splice(index,0,[...updatedRow]);
      const rowindexedData = updatedDataSheet.map((row, rowIndex) => {
        return row.map(cell => {
          const updatedClassName = cell.className?.replace(/cellClass_\d+_(\d+)/g, `cellClass_${rowIndex}_$1`);
          return {
            ...cell,
            className: updatedClassName ?? cell.className
          };
        });
      });
      setSheetData([...rowindexedData])

}

  const removeRow = (e) => {
    let jsonSpreadsheetData = JSON.stringify(sheetData);
    let inSheetData = JSON.parse(jsonSpreadsheetData);
    setSpreadsheetErrors([]);
    if (count % 2 === 0) {
      const newRows = createEmptySheetRows(10, []);
      setSheetData([...newRows]);
    } else {
      let row = activeCell.row;
      let deletedData = inSheetData.filter((data, index) => index !== row);
      ReactDOM.flushSync(() => {
        setSheetData([...deletedData]);
      });
    }
  };

  const selectAllCells = (e) => {
    setCount((prev) => prev + 1);
    let updatedSheetData = [];
   

    if (count % 2 !== 0) {
      updatedSheetData = sheetData.map((row, rowIndex) => {
        return row.map((cell, colIndex) => {
          return {
            ...cell,
            className: `selectcell-class cellClass cellClass_${rowIndex}_${colIndex}`,
          };
        });
      });
    } else {
      updatedSheetData = sheetData.map((row, rowIndex) => {
        return row.map((cell, colIndex) => {
          return {
            ...cell,
            className: `cellClass cellClass_${rowIndex}_${colIndex}`,
          };
        });
      });
    }

    setSheetData(updatedSheetData);
  };

  const handleActiveCellChange = (activeCell) => {
    setActiveCell({});
    console.log("ActiveCell:", activeCell);
    setActiveCell(activeCell);
  };


  const handleCellKeyDown = (keyboardEvent) => {
    console.log("keyDownEvent.", keyboardEvent.target.value);
    // const searchText = keyboardEvent.target.value;

    if (activeCell && Object.keys(activeCell).length > 0) {
      if (
        sheetData[activeCell.row][activeCell.column].type === "number" &&
        keyboardEvent.target.value
      ) {
        keyboardEvent.target.value = keyboardEvent.target.value.replace(
          /[^0-9]$/g,
          ""
        );
      }
    }
  };

  const handleModeChange = (mode) => {
    console.log("ModeCHanged to:", mode);
    // if (mode === 'edit') {
    //     setEditingCell
    // }
  };

  const onCellCommitHandle = (prevCell, nextCell, coordinates) => {
    console.log(
      "OnCellChangesCommit-prevCell:",
      prevCell,
      "nextCell:",
      nextCell,
      "coordinates:",
      coordinates
    );
  };
  const goToModuleHome = () => {
    navigate("/procurement/warehouse-transfers");
  };
  const handleOnContinue = async () => {
    goToModuleHome();
  };
  const handleCellHover = (rowIndex, colIndex, errorDetails) => {
    const error = errorDetails.find(
      (err) => parseInt(err.row) === rowIndex && parseInt(err.col) === colIndex
    );
    setHoveredCell({
      row: rowIndex,
      col: colIndex,
      errorMessage: error?.message || '',
    });
    
  };
  
  const handleCellMouseOut = () => {
    setHoveredCell(null);
 
  };
  

  
  
  const grnPODetailsErrorComp = (ExtraComponent, errorDetails) => {

    return (props) => <ExtraComponent {...props} errorDetails={errorDetails} />;
  };

const TooltipDataViewer = ({ cell, row, column, errorDetails }) => {
  const isHovered =
    hoveredCell?.row === row && hoveredCell?.col === column;

  return (
    <>
      {cell && (
        <span
          style={{ pointerEvents: 'auto', position: 'relative' }}
          onMouseEnter={() => handleCellHover(row, column, errorDetails)}
          onMouseLeave={handleCellMouseOut}
        >
          {cell.value === '' ? '\u00A0' : cell.value}

          {isHovered && hoveredCell.errorMessage && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: '0',
                background: '#fcb9b9',
                color: '#ab0505',
                padding: '4px 12px',
                borderRadius: '4px',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                zIndex: 1000,
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
              }}
            >
              {hoveredCell.errorMessage}
            </div>
          )}
        </span>
      )}
    </>
  );
};

  return (
    <>
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
        <div className="sheet-container sm-scrollbar">
          <div className="header mb-3 flexRow justifyContentSpaceBetween">
            <div className="leftBlock alignItemsCenter">
              <button
                onClick={(e) => selectAllCells(e)}
                className="alignItemsCenter margRight10 flexRow add-item-button-all"
              >
                {count % 2 === 0 ? (
                  <BiSolidSelectMultiple style={{ marginRight: "5px" }} />
                ) : (
                  <FaRegCheckSquare style={{ marginRight: "5px" }} />
                )}
                Select All
              </button>

              <button
                onClick={(e) => removeRow(e)}
                className="remove-button ml-2"
              >
                {" "}
                <RiDeleteBin6Line
                  style={{ marginRight: "5px", marginBottom: "3px" }}
                />
                {t("buttons.deleteRows")}
              </button>
             <button onClick={ (e) => {insertRowAbove(e)} }
              className="alignItemsCenter flexRow insert-button"><FaArrowUp  style={{marginRight:'5px'}} />{ t('buttons.insertRows') }</button>
            </div>

            {spreadsheetErrors.length >= 1 ? (
              <div
                className={`padding4 margTop9-5 alert alert-${
                  spreadsheetErrors[0].message.includes("successfully")
                    ? "success"
                    : "danger"
                }`}
              >
                {spreadsheetErrors.length >= 1
                  ? spreadsheetErrors[0]?.message
                  : null}
              </div>
            ) : null}
          </div>

          <div className="se-titlebar">
            <h6>Edit Slab</h6>
          </div>

          <Spreadsheet
            
            className="spread-sheet"
            data={sheetData}
            columnLabels={sheetLabels}
            darkMode={true}
         
            onChange={(newData) => {
              setSheetData(newData);
              validateSheetData(newData);
            }}
            onActivate={handleActiveCellChange}
            onKeyDown={handleCellKeyDown}
            onModeChange={handleModeChange}
            onSelect={handleRowClick}
            onCellCommit={onCellCommitHandle}
            onMouseEnter={(e) => handleCellHover(e.rowIndex, e.colIndex)} 
            onMouseLeave={handleCellMouseOut} 
            DataViewer={grnPODetailsErrorComp(TooltipDataViewer, errorDetails)}
           
          />

          <div className="flexRow alignItemsCenter margTop8">
            <button
              onClick={() => addRowsToSheet()}
              className="add-item-button"
              title={t("spreadsheet.addmoreRows")}
            >
              {t("buttons.addRows")}
            </button>
          </div>
        </div>

        {Boolean(state.isInvalidAccess) && (
          <AlertModal
            title={"Alert: Invalid Access"}
            customModalStyle={modelStyle}
            description={state.message}
            onContinue={handleOnContinue}
            onClose={handleOnContinue}
          />
        )}
      </div>
    </>
  );
};
